import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface ILeagueList {
    timestamp?: string
    can_join?: boolean
    created_at?: number
    created_by?: string
    end_at?: number
    end_urls: {en: string; ko: string}
    filter?: {min_balance?: string; exchange?: string}
    icon?: string
    id?: string
    is_active?: boolean
    is_joined?: boolean
    autojoin?: boolean
    promote?: boolean
    members_count?: number
    my_league_rank?: number
    my_league_score?: number
    name?: string
    names?: {ko: string; en: string}
    prize_pool?: string
    prize_pools?: {en: string; ko: string}
    rank?: number
    register_by?: number
    start_at?: number
    start_urls?: {en: string; ko: string}
    subtitles?: {en: string; ko: string}
    thumbnails?: {en: string; ko: string}
    type?: string
    meta?: {theme_color?: string; banner_pc?: string; banner_mobile?: string}
    show?: number
}

export const getLeagueList = async (size: number, current_page: number = 1): Promise<ApiRes<ILeagueList[]>> => {
    return await apiGet(
        API_URL,
        `admin/leagues?page_size=${size}&current_page=${current_page}&sort=desc&sort_key=start_at`,
    )
}
